import React, { useEffect, useState } from "react";
import CustomDropdown from "../../../../components/customDropdown";
import { GetPeriodTypeAPI } from "../../../../lib/common-service";
import { Label } from "@progress/kendo-react-labels";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { Checkbox } from "@progress/kendo-react-inputs";
import { executionDataSelector } from "../../../../redux/selectors/custom-selector";
import { changeCancelBtnState, changeUpdateBtnState } from "../../../../utils/utils";
import { setExecutionData } from "../../../../redux/actions/rule-library-actions";

const CHECKBOX_ARRAY = [
  {
    label: "Rollable Result",
    key: "is_rollable",
  },
  {
    label: "Generate Zero Value",
    key: "generate_zero_result",
  },
];

const ExecutionSettings = (restProps) => {
  const executionReduxData = useSelector(executionDataSelector, shallowEqual);
  const dispatch = useDispatch();
  const [periodsTypeFields, setPeriodTypeFields] = useState({
    periodTypeValue: {
      period_type_mstr_key: null,
      period_type_name: "All Periods",
      in_period_start_date: "",
      in_period_end_date: "",
    },
    periodTypeData: [],
    isPeriodTypeDataLoading: true,
  });

  const [periodTypeList, setPeriodTypeList] = useState([]);
  const [checkboxData, setCheckBoxData] = useState({
    ...executionReduxData?.executionData,
  });

  useEffect(() => {
    getPeriodsDataType();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (executionReduxData?.executionData) {
      setCheckBoxData({
        ...executionReduxData?.executionData,
      });
    }
  }, [executionReduxData?.executionData]);

  useEffect(() => {
    if (periodTypeList.length > 0) {
      setPeriodTypeFields({
        ...periodsTypeFields,
        periodTypeValue: periodTypeList.find(
          (x) => x.period_type_mstr_key === executionReduxData?.executionData?.period_type_mstr_key || null
        ),
        isPeriodTypeDataLoading: false,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [executionReduxData?.executionData.period_type_mstr_key, periodTypeList]);

  /**
   * Get Periods Data Type
   */
  const getPeriodsDataType = async () => {
    let periodTypeData = {
      in_filter: "AND a.period_type_hierarchy_level IS NOT NULL",
      in_sort_number: null,
      in_sort_order: null,
    };
    let res = await GetPeriodTypeAPI(periodTypeData, dispatch);
    if (res.length > 0) {
      res.unshift({
        period_type_name: "All Periods",
        period_type_mstr_key: null,
      });
      setPeriodTypeList(res);
      setPeriodTypeFields({
        ...periodsTypeFields,
        periodTypeData: res,
        periodTypeValue: res.find(
          (x) => x.period_type_mstr_key === executionReduxData?.executionData?.period_type_mstr_key || null
        ),
        isPeriodTypeDataLoading: false,
      });
    } else {
      setPeriodTypeFields({
        ...periodsTypeFields,
        isPeriodTypeDataLoading: false,
      });
    }
  };

  const handleChangeDropdown = (e, name, key) => {
    setPeriodTypeFields({
      ...periodsTypeFields,
      [name]: e,
    });
    dispatch(
      setExecutionData({
        executionData: {
          ...executionReduxData.executionData,
          [key]: e.period_type_mstr_key,
        },
      })
    );
    restProps?.onDataChange?.();
    changeCancelBtnState("enable", "grid-incell-cancel-comp-rule");
    changeUpdateBtnState("enable", "grid-incell-update-comp-rule");
  };

  const handleCheckBoxChange = (e, key) => {
    dispatch(
      setExecutionData({
        executionData: {
          ...executionReduxData.executionData,
          [key]: e.target.value ? 1 : 0,
        },
      })
    );

    restProps?.onDataChange?.();
    changeCancelBtnState("enable", "grid-incell-cancel-comp-rule");
    changeUpdateBtnState("enable", "grid-incell-update-comp-rule");
  };

  return (
    <>
      <div className="inner-title-head">
        <h1 key={restProps.key}>Execution Settings</h1>
      </div>
      <div className="inner-title-cont wrapfrequency">
        <div className="k-form-field-wrap-popup frequencydrp">
          <Label className="innerlabletext" style={{ width: "100%" }}>
            {"Frequency*: "}
          </Label>
          <CustomDropdown
            name={"periodTypeValue"}
            data={periodsTypeFields.periodTypeData}
            textField="period_type_name"
            onOpen={(dataValue) => {
              setPeriodTypeFields({
                ...periodsTypeFields,
                periodTypeData: dataValue,
              });
            }}
            dataItemKey="period_type_mstr_key"
            valueData={periodTypeList.find(
              (c) => c.period_type_mstr_key === periodsTypeFields?.periodTypeValue?.period_type_mstr_key || null
            )}
            onChange={(e, name) => {
              handleChangeDropdown(e, name, "period_type_mstr_key");
            }}
            filterable={true}
            onFilterChange={(dataValue) => {
              setPeriodTypeFields({
                ...periodsTypeFields,
                periodTypeData: dataValue,
              });
            }}
            autoClose={false}
            autoBind={true}
            isSelectALl={true}
            dataList={periodTypeList}
            loading={periodsTypeFields.isPeriodTypeDataLoading}
            style={{
              width: "100%",
            }}
            disabled={restProps.pageProps.writeAccess === 0 ? true : false}
          />
        </div>
        {CHECKBOX_ARRAY.map((item, id) => {
          return (
            <div className="k-form-field-wrap-popup execution-checkbox" key={id}>
              <Checkbox
                checked={checkboxData[item.key] ? true : false}
                label={item.label}
                className={"k-checkbox-label innerlabletext"}
                style={{
                  display: "inline-block",
                }}
                onChange={(e) => (handleCheckBoxChange(e, item.key) ? true : false)}
                disabled={restProps.pageProps.writeAccess === 0 ? true : false}
              />
            </div>
          );
        })}
      </div>
    </>
  );
};

export default ExecutionSettings;
